export default {
  cancelButton: 'Cancelar',
  dateRangeLabel: 'Intervalo de tempo *',
  periods: {
    today: 'Hoje',
    yesterday: 'Ontem',
    last24hours: 'Últimas 24 horas',
    currentWeek: 'Semana atual',
    currentMonth: 'Mês atual',
    lastMonth: 'Mês passado',
    last7days: 'Últimos 7 dias',
    last30days: 'Últimos 30 dias',
  },
  previousPeriods: {
    today: 'ontem',
    yesterday: 'anteontem',
    last24hours: 'nas 24 horas anteriores',
    currentWeek: 'na semana passada',
    currentMonth: 'no mês passado',
    lastMonth: 'no mês retrasado',
    last7days: 'nos 7 dias anteriores',
    last30days: 'nos 30 dias anteriores',
    custom: 'no mesmo intervalo anterior',
  },
};
